import React, { useState } from "react";
import { useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { getAllCarrierServices } from "../../store/actions";

/*istanbul ignore next */
const MonthFilter = (props) => {
    const { handleApplyFilter, loader } = props;
    const [allCarriers, setAllCarriers] = useState([]);
    const dispatch = useDispatch();
    const carriers = useSelector((state) => state.shipment.carriers);
    const [formData, setFormData] = useState({
        reportTypes: ['USPSPREMIUM'],
        startDate: null,
        endDate: null
    });
    const carrierOptions = allCarriers?.map((carrier) => ({
        label: carrier.carrierCompanyName,
        value: carrier.carrierCompanyName
    })) || [];

    useEffect(() => {
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        setFormData((prev) => ({
            ...prev,
            startDate: firstDay,
            endDate: lastDay,
        }));
    }, []);

    useEffect(() => {
        if (carriers.length) {
            setAllCarriers(carriers);
        }
    }, [carriers]);

    useEffect(() => {
        if (!carriers.length) {
            dispatch(getAllCarrierServices({}));
        }
    }, []);

    const handleMonthChange = (date, type) => {
        if (type === 'from') {
            setFormData((prev) => ({
                ...prev,
                startDate: date
            }));
            if (formData.endDate && date > formData.endDate) {
                setFormData((prev) => ({
                    ...prev,
                    endDate: null
                }));
            }
        } else {
            const year = date.getFullYear();
            const month = date.getMonth();
            const lastDay = new Date(year, month + 1, 0); // 0 → last day of month
            setFormData((prev) => ({
                ...prev,
                endDate: lastDay
            }));
        }
    };

    const handleCarrierMultiChange = (selected) => {
        setFormData((prev) => ({
            ...prev,
            reportTypes: (selected || []).map((option) => option.value)
        }));
    };

    const handleApply = () => {
        handleApplyFilter(formData);
    };

    return (
        <div className="month-filter-container">
            <div className="row">
                <div className="col-lg-3 col-md-6 col-sm-12 mobMb-10">
                    <DatePicker
                        selected={formData.startDate}
                        onChange={(date) => handleMonthChange(date, 'from')}
                        dateFormat="MMM yyyy"
                        showMonthYearPicker
                        placeholderText="Select From Month"
                        className="datepicker-input"
                        monthClassName={(date) => {
                            if (formData.endDate && date > formData.endDate) return "disabled-month";
                            return "";
                        }}
                        onKeyDown={(e) => {
                            e.preventDefault();
                        }}
                    />
                </div>

                <div className="col-lg-3 col-md-6 col-sm-12 mobMb-10">
                    <DatePicker
                        selected={formData.endDate}
                        onChange={(date) => handleMonthChange(date, 'to')}
                        dateFormat="MMM yyyy"
                        showMonthYearPicker
                        placeholderText="Select To Month"
                        minDate={formData.startDate}
                        className="datepicker-input"
                        monthClassName={(date) => {
                            if (formData.startDate && date < formData.startDate) return "disabled-month";
                            return "";
                        }}
                        onKeyDown={(e) => {
                            e.preventDefault();
                        }}
                    />
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12 mobMb-10">
                    <Select
                        isMulti
                        closeMenuOnSelect={false}
                        inputId="carrierSelect"
                        placeholder="Select Carriers"
                        options={carrierOptions}
                        value={carrierOptions.filter((option) => formData.reportTypes.includes(option.value))}
                        onChange={handleCarrierMultiChange}
                        className="activeSellerListInput"
                        classNamePrefix="list"
                    />
                </div>
                <div className="col-lg-2 col-md-6 col-sm-12 mobMb-10">
                    <button className="btn filterButton" disabled={!formData.startDate || !formData.endDate || !formData.reportTypes.length || loader} onClick={handleApply}>Apply Filter</button>
                </div>
            </div>
        </div>
    );
};

MonthFilter.propTypes = {
    handleApplyFilter: PropTypes.func,
    loader: PropTypes.bool
};

export default MonthFilter;
